import { useDispatch } from "react-redux";
import DuplicateDefinitionLookupFields from "./DuplicateDefinitionLookupFields";
import DuplicateDefinitionRowFiltering from "./DuplicateDefinitionRowFiltering";
import { useSelector } from "react-redux";
import { selectUserToken } from "../../../../../features/userSlice";
import { useSearchParams } from "react-router-dom";
import { UniqueDefinitionsEndpointLogic } from "../../../../../logic/DataCollection/Unifier/UniqueDefinitionsEndpointLogic";
import {
  setDestinationTablesData,
  setInitialDuplicateData,
  setInterfaceData,
  setLoading,
} from "../../../../../features/uniqueDefSlice";
import { useEffect, useState } from "react";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";

const DuplicateDefinition = () => {
  const dispatch = useDispatch();
  const oauthTokenHeader: any = useSelector(selectUserToken);
  const [searchParams] = useSearchParams();

  const {
    loading,
    uniqueDefinitionDataAll,
    // initialDuplicateData,
  } = useSelector((state: any) => state.uniqueDefinition);

  const [, /*showLookupFieldsEdit*/ setShowLookupFieldsDuplicate] =
    useState(false);
  useEffect(() => {
    const fetchData = async () => {
      dispatch(setLoading(true));
      try {
        // Await both API calls in parallel
        await Promise.all([
          UniqueDefinitionsEndpointLogic.getInterface(
            oauthTokenHeader,
            setInterfaceData
          ),
          UniqueDefinitionsEndpointLogic.getDestinationTables(
            oauthTokenHeader,
            setDestinationTablesData
          ),
          UniqueDefinitionsEndpointLogic.getAllUnifierUniqueDefinitions(
            oauthTokenHeader
          ),
        ]);
      } finally {
        dispatch(setLoading(false));
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oauthTokenHeader, dispatch]);

  useEffect(() => {
    const idFromUrl = searchParams.get("duplicate_id");
    if (idFromUrl && uniqueDefinitionDataAll?.length > 0) {
      const matched = uniqueDefinitionDataAll.find(
        (item: any) => item.id === Number(idFromUrl)
      );
      if (matched) {
        dispatch(setInitialDuplicateData(matched));
      }
    }
  }, [searchParams, uniqueDefinitionDataAll, dispatch]);
  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <DuplicateDefinitionRowFiltering
            setShowLookupFieldsDuplicate={setShowLookupFieldsDuplicate}
          />
          <DuplicateDefinitionLookupFields />
        </>
      )}
    </>
  );
};

export default DuplicateDefinition;
